var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 14.398a.6.6 0 0 1 .6.6v4a2.6 2.6 0 0 1-2.6 2.6H5a2.6 2.6 0 0 1-2.6-2.6v-4a.6.6 0 1 1 1.2 0v4a1.4 1.4 0 0 0 1.4 1.4h14a1.4 1.4 0 0 0 1.4-1.4v-4a.6.6 0 0 1 .6-.6m-9-12a.6.6 0 0 1 .6.6v10.553l3.976-3.977a.599.599 0 1 1 .848.848l-5 5a.6.6 0 0 1-.144.102q-.025.016-.053.028-.016.006-.035.01-.037.016-.077.024a.6.6 0 0 1-.231 0q-.04-.009-.077-.024-.018-.004-.036-.01-.027-.013-.052-.028a.6.6 0 0 1-.143-.102l-5-5a.599.599 0 1 1 .848-.848l3.976 3.977V2.998a.6.6 0 0 1 .6-.6"
  })));
};
export default SvgDownload;